import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { NotificationService } from 'src/app/services/notification.service';
import { ConfirmComponent } from 'src/app/support/confirm/confirm.component';
import { CarModel } from 'src/typings';
import { CarModelService } from '../car-model.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  set model(model: CarModel) {
    this._model = model;
    this.profileForm.controls.description.setValue(model.description);
    this.profileForm.controls.manufacture_date_from.setValue(model.manufacture_date_from);
    this.profileForm.controls.manufacture_date_to.setValue(model.manufacture_date_to);
    this.profileForm.controls.body.setValue(model.body);
  }

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  _model: CarModel | undefined;

  profileForm: UntypedFormGroup = this.fb.group({
    description: new UntypedFormControl(),
    manufacture_date_from: new UntypedFormControl(),
    manufacture_date_to: new UntypedFormControl(),
    body: new UntypedFormControl()
  });

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private carModelService: CarModelService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.loadProfile(params.id);
    });
  }

  async loadProfile(id: number) {
    this.loading = true;
    try {
      const result = await firstValueFrom(
        this.carModelService.search({
          id
        })
      );
      this.loading = false;
      this.model = result.data[0];
    } catch (err) {
      console.error(err);
      this.loading = false;
    }
  }

  save() {
    if (!this._model) return;
    this.loading = true;
    this.carModelService
      .update({
        id: this._model.id,
        description: this.profileForm.value.description,
        manufacture_date_from: this.profileForm.value.manufacture_date_from,
        manufacture_date_to: this.profileForm.value.manufacture_date_to,
        body: this.profileForm.value.body
      })
      .subscribe(
        (model) => {
          this.loading = false;
          this.notificationService.notice(`Модель № ${this._model?.id} сохранена!`);
          this.model = model;
        },
        (err) => {
          this.loading = false;
          this.notificationService.warning(err.message);
        }
      );
  }

  delete(dialog?: MatDialogRef<ConfirmComponent>) {
    if (!this._model) return;
    this.loading = true;
    this.carModelService.delete(this._model.id).subscribe(
      () => {
        this.loading = false;
        this.notificationService.notice(`Модель № ${this._model?.id} удалена`);
        this.router.navigateByUrl('/catalogue/cars');
        dialog?.close();
      },
      (err) => {
        this.loading = false;
        this.notificationService.warning(err.message);
        dialog?.close();
      }
    );
  }

  openConfirmDialog() {
    const dialogRef = this.dialog.open(ConfirmComponent);
    dialogRef.componentInstance.confirmEvent.subscribe((event) => {
      if (event === false) dialogRef.close();
      if (event === true) this.delete(dialogRef);
    });
  }
}
